/** Professional-grade feature sheet shown on the homepage (manufacturer-advertised). */
export const featureSpecs = [
  { value: '13', unit: 'LED', label: '13-LED lighting system' },
  { value: '3000', unit: 'mAh', label: 'Rechargeable battery' },
  { value: 'USB-C', unit: '', label: 'Charging' },
  { value: 'IP68', unit: '', label: 'Waterproof specification' },
  { value: '16', unit: 'colors', label: 'Colors and dynamic modes' },
  { value: 'Remote', unit: '', label: 'Remote control included', note: 'Uses 2 AAA batteries (not included)' },
  { value: 'Magnetic', unit: '', label: 'Magnetic Mount System' },
  { value: 'ABS', unit: '', label: 'Durable ABS construction' },
];
